<template>
    <v-container
        fill-height
        fluid
        class="tw-flex tw-items-center tw-justify-center"
    >
        <SignUpForm :key="signUpFormKey" @success="onSuccess" />
    </v-container>
</template>

<script>
import SignUpForm from '@/components/auth/SignUpForm'
import { mapGetters } from 'vuex'
import { AUTHENTICATION_MODULE_NAME } from '@/store/moduleNames'
import { useToast } from '@vibefam/toast/composable/useToast'
export default {
    props: ['block'],
    components: {
        SignUpForm,
    },
    data() {
        return {
            signUpFormKey: false,
        }
    },
    computed: {
        ...mapGetters({
            isUserAuth: `${AUTHENTICATION_MODULE_NAME}/isUserAuth`,
        }),
    },
    setup() {
        const { showSuccessToast } = useToast()
        return {
            showSuccessToast,
        }
    },
    methods: {
        onSuccess(familySignup = false) {
            this.showSuccessToast(
                `${this.$t('message.welcomeNewMember')} ${this.$t('message.signupSuccess')}`
            )
            if (familySignup) {
                this.routeToFamilyProfile()
            } else {
                this.routeToClasses()
            }
        },
        routeToClasses() {
            const hash = this.$route.hash
            const studioRoute = this.$route.params.studioRoute
            const classesPageRoute = `/${studioRoute}/classes${hash}`
            this.$router.push(classesPageRoute)
        },
        routeToFamilyProfile() {
            this.$router.push(
                `/${this.$route.params.studioRoute}/profile?addFamilyMember=true`
            )
        },
    },
    watch: {
        isUserAuth: {
            immediate: true,
            handler() {
                if (this.isUserAuth) {
                    this.routeToClasses()
                }
            },
        },
    },
}
</script>
